const resource = {
    resource_identifier_in_use: '"El identificador de API {{indicator}} ya está en uso',
    cannot_delete_management_api: 'No se puede eliminar la API de administración de Logto.',
    cannot_modify_management_api: 'No se puede modificar la API de administración de Logto.',
};
export default Object.freeze(resource);
